import React, { forwardRef } from "react";
import { StyledButton } from "../../HeaderStyles";
import PreviewIcon from "src/icons/PreviewIcon";
import PhoneRingingIcon from "src/icons/PhoneRingingIcon";
import { usePreviewButton } from "./PreviewButton.hook";
import Tooltip from "@hyro-components/Tooltip";
import { CircularProgress } from "@mui/material";

const PreviewButton = forwardRef(({ handleOpenDropdown }, ref) => {
  const {
    isPreviewDisabled,
    isLoadingPreview,
    isPhone,
    isBuilding,
    getButtonText,
    handlePreviewClick,
    getTooltipText
  } = usePreviewButton();

  const buttonIcon = () => {
    if (isLoadingPreview) {
      return null;
    }

    if (isBuilding) {
      return <CircularProgress size={16} sx={{ color: "grey.400" }} data-testid="preview-button-loading-icon" />;
    }

    return isPhone ?
      <PhoneRingingIcon size={20} disabled={isPreviewDisabled} testId="preview-button-phone-icon" /> :
      <PreviewIcon size={20} disabled={isPreviewDisabled} testId="preview-button-web-icon" />;
  };

  return (
    <Tooltip tooltipStyle={{ whiteSpace: "pre-line" }} title={getTooltipText()} testId="preview-button">
      <StyledButton
        ref={ref}
        data-testid={isPhone ? "page-preview-voice-button" : "page-preview-web-button"}
        disabled={isPreviewDisabled || isBuilding}
        loading={isLoadingPreview}
        variant="outlined"
        startIcon={buttonIcon()}
        onClick={(e) => handlePreviewClick(e, handleOpenDropdown)}
      >
        {getButtonText()}
      </StyledButton>
    </Tooltip >
  );
});

PreviewButton.displayName = "PreviewButton";

export default PreviewButton;
